import { render, staticRenderFns } from "./AdminPayment.vue?vue&type=template&id=2a123fd5"
import script from "./AdminPayment.vue?vue&type=script&lang=js"
export * from "./AdminPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports